/**
 * TEMPHOR - filtros e ordenação do catálogo (snippets/temphor-catalog-grid.liquid).
 *
 * Todos os relógios já vêm na página; aqui só escondemos/reordenamos os cards.
 * Filtros: dentro de um grupo vale qualquer opção marcada (OU); entre grupos,
 * todas as condições (E). A escolha fica no endereço para poder ser compartilhada
 * ou usada em anúncios: ?marca=casio,seiko&preco=2000-5000&mov=automatico&tam=39-41&genero=feminino&ordem=preco-asc
 * O sort_by da Shopify (ex.: link "Menores preços" da home) também é entendido.
 */
(() => {
  const PRICE_BUCKETS = [
    { value: 'ate-2000', label: 'Até R$ 2.000', test: (c) => c < 200000 },
    { value: '2000-5000', label: 'R$ 2.000 a R$ 5.000', test: (c) => c >= 200000 && c < 500000 },
    { value: '5000-10000', label: 'R$ 5.000 a R$ 10.000', test: (c) => c >= 500000 && c < 1000000 },
    { value: '10000-mais', label: 'Acima de R$ 10.000', test: (c) => c >= 1000000 },
  ];
  const SIZE_BUCKETS = [
    { value: 'ate-38', label: 'Até 38 mm', test: (mm) => mm <= 38.5 },
    { value: '39-41', label: '39 a 41 mm', test: (mm) => mm > 38.5 && mm <= 41.5 },
    { value: '42-44', label: '42 a 44 mm', test: (mm) => mm > 41.5 && mm <= 44.5 },
    { value: '45-mais', label: '45 mm ou mais', test: (mm) => mm > 44.5 },
  ];
  const MOVEMENT_ORDER = ['automatico', 'corda-manual', 'quartzo', 'solar'];
  const GENDERS = [
    { value: 'masculino', label: 'Masculino' },
    { value: 'feminino', label: 'Feminino' },
    { value: 'unissex', label: 'Unissex' },
  ];
  const SHOPIFY_SORT = { 'price-ascending': 'preco-asc', 'price-descending': 'preco-desc', 'title-ascending': 'az' };
  const SORTS = ['colecao', 'procura', 'preco-asc', 'preco-desc', 'az'];

  function init(root) {
    const grid = root.querySelector('[data-grid]');
    const sheet = root.querySelector('[data-sheet]');
    const groupsEl = root.querySelector('[data-groups]');
    const sortEl = root.querySelector('[data-sort]');
    const countEl = root.querySelector('[data-count]');
    const badgeEl = root.querySelector('[data-filter-count]');
    const activeEl = root.querySelector('[data-active]');
    const emptyEl = root.querySelector('[data-empty]');
    const seeEl = root.querySelector('[data-see]');
    if (!grid || !sortEl) return;

    const items = [...grid.querySelectorAll('.temphor-product-card')].map((el) => ({
      el,
      marca: el.dataset.marca || '',
      marcaNome: el.dataset.marcaNome || '',
      mov: el.dataset.mov || '',
      movNome: el.dataset.movNome || '',
      tam: parseFloat(el.dataset.tam) || 0,
      preco: Number(el.dataset.preco) || 0,
      genero: el.dataset.genero || '',
      rank: Number(el.dataset.rank),
      pos: Number(el.dataset.pos) || 0,
      disp: el.dataset.disp !== '0',
      titulo: (el.querySelector('.temphor-product-title')?.textContent || '').trim(),
    }));

    /* ---------- grupos de filtro (só as opções que existem nesta página) ---------- */

    const groups = [];
    const brands = new Map();
    items.forEach((it) => it.marca && brands.set(it.marca, it.marcaNome));
    groups.push({
      key: 'marca',
      label: 'Marca',
      options: [...brands].sort((a, b) => a[1].localeCompare(b[1], 'pt-BR')).map(([value, label]) => ({ value, label, test: (it) => it.marca === value })),
    });
    groups.push({
      key: 'preco',
      label: 'Preço',
      options: PRICE_BUCKETS.map((b) => ({ value: b.value, label: b.label, test: (it) => b.test(it.preco) })),
    });
    const movements = new Map();
    items.forEach((it) => it.mov && movements.set(it.mov, it.movNome));
    groups.push({
      key: 'mov',
      label: 'Movimento',
      options: [...movements]
        .sort((a, b) => (MOVEMENT_ORDER.indexOf(a[0]) + 99) % 99 - (MOVEMENT_ORDER.indexOf(b[0]) + 99) % 99)
        .map(([value, label]) => ({ value, label, test: (it) => it.mov === value })),
    });
    groups.push({
      key: 'tam',
      label: 'Tamanho da caixa',
      options: SIZE_BUCKETS.map((b) => ({ value: b.value, label: b.label, test: (it) => it.tam > 0 && b.test(it.tam) })),
    });
    groups.push({
      key: 'genero',
      label: 'Gênero',
      options: GENDERS.map((g) => ({ value: g.value, label: g.label, test: (it) => it.genero.split(' ').includes(g.value) })),
    });
    // Some com opções que não têm nenhum relógio aqui; esconde grupos sem escolha real.
    groups.forEach((g) => {
      g.options = g.options.filter((o) => items.some(o.test));
    });
    const activeGroups = groups.filter((g) => g.options.length > 1);

    /* ---------- estado ---------- */

    const defaultSort = root.dataset.defaultSort || 'procura';
    const state = { sort: defaultSort, filters: {} };
    activeGroups.forEach((g) => (state.filters[g.key] = new Set()));

    const params = new URLSearchParams(window.location.search);
    activeGroups.forEach((g) => {
      const raw = params.get(g.key);
      if (!raw) return;
      raw.split(',').forEach((v) => g.options.some((o) => o.value === v) && state.filters[g.key].add(v));
    });
    const askedSort = params.get('ordem') || SHOPIFY_SORT[params.get('sort_by')];
    if (askedSort && SORTS.includes(askedSort) && [...sortEl.options].some((o) => o.value === askedSort)) state.sort = askedSort;
    sortEl.value = state.sort;

    /* ---------- ordem "Mais procurados" ---------- */

    // Uma marca só: a ordem da tabela. Várias marcas: intercala as marcas (a mais
    // procurada primeiro), cada uma na sua ordem - assim a primeira tela mostra
    // relógios de marcas diferentes em vez de só a primeira do alfabeto.
    const procuraOrder = (() => {
      const ranked = items.filter((it) => it.rank < 9999).sort((a, b) => a.rank - b.rank);
      const rest = items.filter((it) => !(it.rank < 9999)).sort((a, b) => a.pos - b.pos);
      const byBrand = new Map();
      ranked.forEach((it) => {
        if (!byBrand.has(it.marca)) byBrand.set(it.marca, []);
        byBrand.get(it.marca).push(it);
      });
      const lists = [...byBrand.values()];
      const out = [];
      for (let i = 0; lists.some((l) => l.length > i); i++) lists.forEach((l) => l[i] && out.push(l[i]));
      return new Map([...out, ...rest].map((it, i) => [it, i]));
    })();

    function sorted() {
      const list = [...items];
      const by = {
        colecao: (a, b) => a.pos - b.pos,
        procura: (a, b) => procuraOrder.get(a) - procuraOrder.get(b),
        'preco-asc': (a, b) => a.preco - b.preco || procuraOrder.get(a) - procuraOrder.get(b),
        'preco-desc': (a, b) => b.preco - a.preco || procuraOrder.get(a) - procuraOrder.get(b),
        az: (a, b) => a.titulo.localeCompare(b.titulo, 'pt-BR'),
      }[state.sort] || ((a, b) => a.pos - b.pos);
      // Esgotados sempre no fim.
      return list.sort((a, b) => (b.disp - a.disp) || by(a, b));
    }

    /* ---------- filtro ---------- */

    function matches(it, skipKey) {
      return activeGroups.every((g) => {
        if (g.key === skipKey) return true;
        const chosen = state.filters[g.key];
        if (!chosen.size) return true;
        return g.options.some((o) => chosen.has(o.value) && o.test(it));
      });
    }

    const plural = (n) => (n === 1 ? '1 relógio' : `${n} relógios`);
    const totalChosen = () => activeGroups.reduce((n, g) => n + state.filters[g.key].size, 0);

    /* ---------- desenho ---------- */

    function renderGroups() {
      groupsEl.innerHTML = '';
      activeGroups.forEach((g) => {
        const fs = document.createElement('fieldset');
        fs.className = 'temphor-catalog__group';
        const lg = document.createElement('legend');
        lg.textContent = g.label;
        fs.appendChild(lg);
        const wrap = document.createElement('div');
        wrap.className = 'temphor-catalog__options';
        g.options.forEach((o) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'temphor-catalog__chip';
          btn.dataset.group = g.key;
          btn.dataset.value = o.value;
          btn.innerHTML = `<span></span><span class="temphor-catalog__chip-n"></span>`;
          btn.firstChild.textContent = o.label;
          btn.addEventListener('click', () => {
            const set = state.filters[g.key];
            set.has(o.value) ? set.delete(o.value) : set.add(o.value);
            update();
          });
          wrap.appendChild(btn);
        });
        fs.appendChild(wrap);
        groupsEl.appendChild(fs);
      });
    }

    function update({ reorder = true } = {}) {
      const order = sorted();
      let visible = 0;
      order.forEach((it) => {
        const show = matches(it);
        it.el.hidden = !show;
        if (show) visible++;
        if (reorder) grid.appendChild(it.el);
      });

      countEl.textContent = plural(visible);
      if (emptyEl) emptyEl.hidden = visible > 0;
      grid.hidden = visible === 0;
      if (seeEl) seeEl.textContent = visible ? `Ver ${plural(visible)}` : 'Nenhum relógio';

      const chosen = totalChosen();
      if (badgeEl) {
        badgeEl.hidden = chosen === 0;
        badgeEl.textContent = chosen;
      }

      // Opções do painel: marcadas + quantos relógios teriam com elas.
      groupsEl.querySelectorAll('.temphor-catalog__chip').forEach((btn) => {
        const g = activeGroups.find((x) => x.key === btn.dataset.group);
        const o = g.options.find((x) => x.value === btn.dataset.value);
        const on = state.filters[g.key].has(o.value);
        const n = items.filter((it) => matches(it, g.key) && o.test(it)).length;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.disabled = !on && n === 0;
        btn.lastChild.textContent = n;
      });

      // Filtros ativos, removíveis com um toque.
      activeEl.innerHTML = '';
      activeGroups.forEach((g) => {
        g.options.forEach((o) => {
          if (!state.filters[g.key].has(o.value)) return;
          const tag = document.createElement('button');
          tag.type = 'button';
          tag.className = 'temphor-catalog__tag';
          tag.setAttribute('aria-label', `Remover filtro ${o.label}`);
          tag.innerHTML = '<span></span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          tag.firstChild.textContent = o.label;
          tag.addEventListener('click', () => {
            state.filters[g.key].delete(o.value);
            update({ reorder: false });
          });
          activeEl.appendChild(tag);
        });
      });
      if (chosen > 1) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'temphor-catalog__tag temphor-catalog__tag--clear';
        clear.textContent = 'Limpar tudo';
        clear.addEventListener('click', clearAll);
        activeEl.appendChild(clear);
      }
      activeEl.hidden = chosen === 0;

      writeUrl();
    }

    function writeUrl() {
      const url = new URL(window.location.href);
      activeGroups.forEach((g) => {
        const v = [...state.filters[g.key]];
        v.length ? url.searchParams.set(g.key, v.join(',')) : url.searchParams.delete(g.key);
      });
      state.sort !== defaultSort ? url.searchParams.set('ordem', state.sort) : url.searchParams.delete('ordem');
      url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      const next = url.pathname + (url.searchParams.toString() ? `?${url.searchParams}` : '') + url.hash;
      if (next !== window.location.pathname + window.location.search + window.location.hash) {
        history.replaceState(history.state, '', next);
      }
    }

    function clearAll() {
      activeGroups.forEach((g) => state.filters[g.key].clear());
      update({ reorder: false });
    }

    /* ---------- painel ---------- */

    function openSheet() {
      if (typeof sheet.showModal === 'function') sheet.showModal();
      else sheet.setAttribute('open', '');
      document.documentElement.classList.add('temphor-catalog-lock');
    }

    function closeSheet() {
      if (typeof sheet.close === 'function' && sheet.open) sheet.close();
      else sheet.removeAttribute('open');
    }

    sheet.addEventListener('close', () => document.documentElement.classList.remove('temphor-catalog-lock'));
    // Toque fora do painel (no fundo escurecido) fecha.
    sheet.addEventListener('click', (e) => {
      if (e.target === sheet) closeSheet();
    });
    root.querySelector('[data-open-filters]')?.addEventListener('click', () => {
      if (!activeGroups.length) return;
      openSheet();
    });
    root.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', closeSheet));
    root.querySelectorAll('[data-clear]').forEach((b) => b.addEventListener('click', clearAll));

    sortEl.addEventListener('change', () => {
      state.sort = sortEl.value;
      update();
    });

    if (!activeGroups.length) root.querySelector('[data-open-filters]')?.setAttribute('hidden', '');
    renderGroups();
    update();
  }

  document.querySelectorAll('[data-temphor-catalog]').forEach(init);
})();
